function parseApiBaseUrl(apiBase) {
  const trimmed = (apiBase || "").trim();
  if (!trimmed) {
    return null;
  }

  try {
    const parsed = new URL(trimmed);
    const pathPrefix = parsed.pathname.replace(/\/+$/, "");
    return {
      origin: `${parsed.protocol}//${parsed.host}`,
      pathPrefix,
    };
  } catch {
    return null;
  }
}

/**
 * Socket.IO host origin (scheme + host). Same host as REACT_APP_BASE_URL.
 */
export function getSocketBaseUrl() {
  const parsed = parseApiBaseUrl(process.env.REACT_APP_BASE_URL);
  return parsed?.origin || "";
}

/**
 * Socket.IO path on the server. When the API lives under /backend, the socket
 * must use /backend/socket.io so traffic is routed to the Node app (not the SPA).
 */
export function getSocketIoPath() {
  const parsed = parseApiBaseUrl(process.env.REACT_APP_BASE_URL);
  if (!parsed) {
    return "/socket.io";
  }

  if (!parsed.pathPrefix) {
    return "/socket.io";
  }

  return `${parsed.pathPrefix}/socket.io`;
}

/**
 * Socket.IO connection settings for poll results and other real-time features.
 */
export function getSocketConnectionConfig() {
  return {
    url: getSocketBaseUrl(),
    path: getSocketIoPath(),
  };
}
